import React from 'react';

import {observer} from 'mobx-react';
import {EntityScoresWidgetGroupHeader} from "./entity-scores-widget.group-header";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {GameCardViewModel} from "../../../../core/components/game-card/view-models/game-card.view-model";
import {List} from "../../../../core/components/misc/list/list";
import {GameCard} from "../../../../core/components/game-card/components/game-card";
import {ACTION_TYPES} from "../../../../core/consts";
import {GAME_CARD} from "../../../../core/components/game-card/game-card.consts";
import {ANALYTICS} from "../../../../third-party-services/analytics/analytics-consts";
import {APP} from "../../../../core/app/consts";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-group.module.scss";
import {ENTITY_SCORES} from "../../entity-scores-widget.consts";
import {IntersectionObserver} from "../../../../core/components/intersection-observer/intersection-observer";
import {NAVIGATION_TABS} from "../../../../modules/navigation-tabs-module/navigation-tabs-module.consts";
import {TagSnippetWidgetAsync} from "../../../tag-snippet-widget/components/tag-snippet-widget.async";

export class EntityScoresGroupProps extends BaseProps {
}

export const EntityScoresWidgetGroup = observer(({
                                                   controller,
                                                   group,
                                                   isLive,
                                                   separateLive,
                                                   index,
                                                   isSideBar
                                                 }: EntityScoresGroupProps) => {
  const games: Array<GameCardViewModel> = isLive ? group.liveGamesArray : (separateLive ? group.notLiveGamesArray : group.gamesArray);
  const shouldRenderGames: Boolean = games?.length > 0

  const {device, terms, state} = controller;
  const {selectedGameId, shouldDisableGameRoute, settings, currentLinkModel, showOdds, shouldRenderMicroData, isWidget, generateTagIndex} = state;
  const {isSmallView} = device;

  const headerProps = {
    controller,
    group
  }

  const onClick = (game: GameCardViewModel) => {
    controller.action(ENTITY_SCORES.ACTION_HANDLERS.gameClick, {
      game,
      settings,
      source: APP.ANALYTICS.SOURCES[currentLinkModel?.name],
      currentLinkModelName: currentLinkModel?.name,
      screenId: currentLinkModel?.params.id,
    });

    return !settings.eventClick && shouldDisableGameRoute;
  }

  const onLineupsClick = (params, game) => {
    controller.action(ACTION_TYPES.lineupsClick, {
      game,
      ...params,
      entityType: ANALYTICS.ENTITY_TYPES.competition,
      tabIndex: NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.lineups,
      entityId: params.gameId
    });

    return false;
  }

  const listProps = {
    items: games,
    ListItem: GameCard,
    itemPropName: 'game',
    listItemProps: {
      device,
      showOdds,
      controller,
      isSmallView,
      i18n: terms,
      selectedGameId,
      isFullGameCard: true,
      forceRender: true,
      shouldDisableRouteChange: shouldDisableGameRoute,
      shouldRenderMicroData,
      shouldRenderScoreboard: true,
      shouldRenderFullScoreboard: true,
      context: GAME_CARD.CONTEXTS.entityScores,
      source: APP.ANALYTICS.SOURCES.sortedEntity,
      gaSource: APP.GOOGLE_ANALYTICS.SOURCES.scoresList,
      lineupsClickEvent: (params, game) => onLineupsClick(params, game),
      onClick: (...params) => onClick(...params)
    }
  }

  const tagSnippetProps = {
    widgetType: 'entityScores',
    source: APP.ANALYTICS.SOURCES.scoresList,
    className: classNames(styles.tag_snippet)
  }

  return (
    shouldRenderGames ?
      <IntersectionObserver className={classNames(styles.container)} style={{minHeight: games?.length * 72}}>
        <EntityScoresWidgetGroupHeader {...headerProps}/>
        <List {...listProps}/>
        {
          !isWidget && !isSideBar && (index === generateTagIndex) ? <TagSnippetWidgetAsync {...tagSnippetProps}/> : null
        }
      </IntersectionObserver> : null
  )
});
